import { API_DOCS_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import checkIcon from "./check-icon.svg"
import Button from "components/ui/Button"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function UseCasesSection() {
  const { getAsset } = usePageAssets()
  const dots = getAsset("api-dots-background-svg")
  return (
    <div className="relative overflow-hidden pb-24">
      <div className="absolute bottom-0 left-1/2 hidden -translate-x-1/2 translate-y-3/4 lg:block">
        <Image src={dots} />
      </div>
      <Heading
        label="Use Cases"
        title="Manage everything as code"
        subtitle={
          <>
            Create powerful charts and dashboards on top of popular cloud data
            warehouses and leading data engines. Through native integration with
            dbt, Preset makes version control of dashboards seamless.
          </>
        }
        decoration="border"
        inverted
      />
      <ul className="mt-10 grid grid-cols-1 gap-x-10 gap-y-4 lg:grid-cols-3">
        <ListItem>User and Team Management</ListItem>
        <ListItem>Dataset Management</ListItem>
        <ListItem>Annotation Layer Management</ListItem>
        <ListItem>Workspace Management</ListItem>
        <ListItem>Chart Management</ListItem>
        <ListItem>Reports</ListItem>
        <ListItem>Database Connection Management</ListItem>
        <ListItem>Dashboard Management</ListItem>
        <ListItem>Permissions Management</ListItem>
      </ul>
      <Button
        className="mt-10"
        color="green"
        size="medium"
        href={API_DOCS_URL}
        trackClick="Read API docs_API"
        target="_blank"
        inverted
      >
        Read API docs
      </Button>
    </div>
  )
}

function ListItem({ children }) {
  return (
    <div className="flex items-center gap-x-6 text-xl text-sage">
      <img className="h-6 w-6" src={checkIcon} alt="Check icon" />
      <div className="flex-1">{children}</div>
    </div>
  )
}

export default UseCasesSection
